export default "__VITE_ASSET__1Z7xmgl$__"